import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Button, makeStyles} from '@material-ui/core'
import CardWithTitle from 'components/atoms/CardWithTitle'
import ProductRegistrationOrganizationListStyle from 'pages/ProductRegistrationOrganization/ProductRegistrationOrganizationList/style'
import BulkSupply from 'pages/ProductRegistrationOrganization/BulkSupply'
import useProductManagement from 'features/productManagement/useProductManagement'
import {TYPE_INDICATOR_PRODUCT} from 'pages/ProductsPages/constant'
import {LIST_TABS_RECHARGE} from 'pages/ProductRegistrationOrganization/constant'

const useStyles = makeStyles(ProductRegistrationOrganizationListStyle)
const ProductRegistrationOrganizationList = () => {
  const {t} = useTranslation()
  const classes = useStyles()

  const [activeTabs, setActiveTabs] = useState<string>(
    LIST_TABS_RECHARGE[0].value,
  )
  const {getPackageList} = useProductManagement()

  useEffect(() => {
    setActiveTabs(LIST_TABS_RECHARGE[0].value)
    getPackageList({
      target: TYPE_INDICATOR_PRODUCT.ALL,
    })
  }, [])
  return (
    <div>
      <CardWithTitle title={t('IProductRegistrationOrganization')}>
        <div className={classes.tabsUnderline}>
          {LIST_TABS_RECHARGE.map((item) => (
            <div key={item.value}>
              <Button
                onClick={() => setActiveTabs(item.value)}
                className={`${classes.tabUnderline} ${
                  activeTabs === item.value ? classes.activeTabs : ''
                }`}
              >
                {t(item.label)}
              </Button>
              {activeTabs === item.value && <div className={classes.active} />}
            </div>
          ))}
          <div className={classes.underlineIndicator} />
        </div>
        <BulkSupply tab={activeTabs} />
      </CardWithTitle>
    </div>
  )
}

export default ProductRegistrationOrganizationList
